import { combineReducers } from 'redux';

import admin from './admin';
import auth from './auth';
import ecap from './ecap';
import onboarding from './onboarding';
import preregistration from './preregistration';
import skills from './skills';
import tenant from './tenant';
import userGameInfo from './userGameInfo';
import userDashboard from './userDashboard';
import currentLocale from './currentLocale';

export const createReducer = () => {
  return combineReducers({
    admin,
    auth,
    ecap,
    onboarding,
    preregistration,
    skills,
    tenant,
    userGameInfo,
    userDashboard,
    currentLocale,
  });
};

export default createReducer();
